import { render, staticRenderFns } from "./ci_badge_link.vue?vue&type=template&id=71cd6369"
import script from "./ci_badge_link.vue?vue&type=script&lang=js"
export * from "./ci_badge_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports